import { render, staticRenderFns } from "./TaxReturnPowerSection.vue?vue&type=template&id=62b99eff&scoped=true&"
import script from "./TaxReturnPowerSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnPowerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b99eff",
  null
  
)

export default component.exports